import { Module, VuexModule } from 'vuex-module-decorators';

@Module({ namespaced: true })
export class I18nStore extends VuexModule {
  list = [
    {
      name: 'English',
      native: 'English',
      iso: 'en-US',
      img: '/img/flags-rounded/united-kingdom.svg',
    },
    {
      name: 'Turkish',
      native: 'Türkçe',
      iso: 'tr-TR',
      img: '/img/flags-rounded/turkey.svg',
    },
    {
      name: 'German',
      native: 'Deutsch',
      iso: 'de-DE',
      img: '/img/flags-rounded/germany.svg',
    },
    {
      name: 'Russian',
      native: 'Русский',
      iso: 'ru-RU',
      img: '/img/flags-rounded/russia.svg',
    },
    {
      name: 'Spanish',
      native: 'Español',
      iso: 'es-ES',
      img: '/img/flags-rounded/spain.svg',
    },
    {
      name: 'French',
      native: 'Français',
      iso: 'fr-FR',
      img: '/img/flags-rounded/france.svg',
    },
    {
      name: 'Italian',
      native: 'Italiano',
      iso: 'it-IT',
      img: '/img/flags-rounded/italy.svg',
    },
    {
      name: 'Portuguese',
      native: 'Português',
      iso: 'pt-PT',
      img: '/img/flags-rounded/portugal.svg',
    },
    {
      name: 'Polish',
      native: 'Polski',
      iso: 'pl-PL',
      img: '/img/flags-rounded/republic-of-poland.svg',
    },
    {
      name: 'Chinese',
      native: '繁體中文',
      iso: 'zh-HK',
      img: '/img/flags-rounded/china.svg',
    },
  ];
}
